<script>
import _ from 'lodash'
import SelfCountService from '@/request/count/self'
import Vue from 'vue'
import VCharts from 'v-charts'
Vue.use(VCharts)
export default {
  name: 'CountOperationSelf',
  components: {},
  props: {
    date: {
      type: Object,
      default () {
        return {
          start: null,
          end: null
        }
      }
    }
  },
  data () {
    return {
      roles: {
        operator: '主刀',
        consultation: '会诊',
        first: '一助',
        second: '二助',
        wash: '洗手',
        tour: '巡回',
        anesthesia: '麻醉'
      },
      dataLoading: false,
      chartData: {
        columns: ['role', 'count'],
        rows: []
      }
    }
  },
  computed: {},
  created: function () {
    this.loadData()
  },
  watch: {
    date () {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      let self = this
      let rows = []
      self.dataLoading = true
      SelfCountService.operation({
        start: self.date.start,
        end: self.date.end
      }).then(res => {
        let data = res.result || {}
        _.forEach(self.roles, (role, key) => {
          if (data[key + 'Count']) {
            rows.push({
              role: role,
              count: data[key + 'Count']
            })
          }
        })
        self.chartData.rows = _.clone(rows)
      }).finally(() => {
        self.dataLoading = false
      })
    }
  },
  filters: {}
}
</script>

<template>
  <ve-pie
    v-loading="dataLoading"
    :data="chartData"
    legend-position="bottom">
    <div class="data-empty" v-if="chartData.rows.length <= 0">没有数据😂</div>
  </ve-pie>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.data-empty {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  color: #888;
  font-size: 14px;
}
</style>
